import React, { Component } from 'react';
import FormError from '../../models/FormError';
import ErrorFieldMessage from './FieldErrorMessage.Component';
import Dropzone from 'react-dropzone';

type FileInputProps = {
    name: string,
    label: string,
    errors?: FormError[],
    maxSize: number,
    filesToLargeValidationMessage: string,
    addFilesLabel: string,
    dragFilesLabel: string,
    id: string,
    fileUploadAllowedFormatsLabel: string
    acceptFormats?: string | string[],
    acceptFormatsLabel?: string

    onChange: (files: File[]) => Promise<FormError[]>,
}

type FileInputState = {
    files: File[],
    errors: FormError[]
}

export default class FileInput extends Component<FileInputProps, FileInputState> {
    constructor(props: FileInputProps) {
        super(props);

        this.state = {
            files: [],
            errors: props.errors?.filter(err => { return err.field === props.name }) ?? [],
        }
    }

    public componentDidUpdate(previousProps: FileInputProps, previousState: FileInputState) {
        if (this.props.errors?.length != previousProps.errors?.length) {
            this.setState({
                errors: this.props.errors?.filter(err => { return err.field === this.props.name }) ?? []
            });
        }
    }

    public addFiles(addedfiles: File[]) {
        let files: File[] = this.state.files;
        let totalfilesSize: number = 0;
        if (files.length > 0) {
            totalfilesSize = files.map(file => { return file.size; }).reduce((sizeA, sizeB) => { return sizeA + sizeB });
        }

        let totalAddedfilesSize: number = 0;
        if (addedfiles.length > 0) {
            totalAddedfilesSize = addedfiles.map(file => { return file.size; }).reduce((sizeA, sizeB) => { return sizeA + sizeB });
        }

        if (totalfilesSize + totalAddedfilesSize <= this.props.maxSize) {
            files = files.concat(addedfiles);
            this.props.onChange(files);

            this.setState({
                files: files
            })
        }
        else {
            alert(this.props.filesToLargeValidationMessage);
        }
    }

    public deleteFile(file: File) {
        let files: File[] = this.state.files;
        files = files.filter(f => f.name !== file.name);

        this.props.onChange(files);

        this.setState({
            files: files
        })
    }

    public render() {
        return <div>
            <label htmlFor={this.props.id}>{this.props.label}</label>
            <Dropzone onDrop={(files) => this.addFiles(files)} accept={this.props.acceptFormats}>
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="d-flex justify-content-center align-items-center form-component-filedrop p-4 cursor-pointer bg-white border-brown-25-alhpa">
                        <img src="/img/svg/icon-paperclip-gray.svg" className="mr-2" alt="" />
                        <span className="text-primary">{this.props.addFilesLabel}</span>
                        &nbsp;
                        <span className="text-brown-100">{this.props.dragFilesLabel}</span>
                        <input {...getInputProps()} id={this.props.id} />
                    </div>
                )}
            </Dropzone>
            <small className="mt-1">{this.props.fileUploadAllowedFormatsLabel} {this.props.acceptFormatsLabel || 'jpg, png, doc, docx, xls, xlsx, odt, ods, pdf, ...'}</small>
            {
                (this.state.files.length > 0) ?
                    <div className="rounded my-2">
                        {
                            (this.state.files.map((file: File, index: number) => {
                                return (
                                    <div className={"d-flex justify-content-between border-left border-right border-bottom " + (index == 0 ? " border-top rounded-top" : "") + " border-brown-25-alpha py-1 px-2 " + (index == (this.state.files.length - 1) ? " rounded-bottom" : "")} key={this.props.name + "-file-" + { index }}>
                                        <div>{file.name}</div>
                                        <button className="btn-no-styling" type="button"
                                            onClick={() => this.deleteFile(file)}
                                            aria-label="remove attachment" >
                                            <img src="/img/svg/icon-x-gray.svg" className="cursor-pointer" alt="" />
                                        </button>
                                    </div>)
                            }))
                        }
                    </div>
                    : <></>
            }
            <ErrorFieldMessage name={this.props.name} errors={this.state.errors}></ErrorFieldMessage>
        </div>
    }
}

